export default __webpack_public_path__ + "static/media/cooking_2020_OV_seemore_SD-ZP2000EU-K_02_201218.8548d291.jpg";